module.exports = __webpack_public_path__ + "static/media/recruitment-mobile-3.a02778b9.png";